/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';

export default class AbstractLayout extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	get key() {
		return ''; // Child classes should override this method
	}

	content() {
		return null; // Child classes should override this method
	}

	view() {
		return <div className={`BannerLayout BannerLayout--${this.key}`}>{this.content()}</div>;
	}
}
